import { UnstyledButton } from '@mantine/core';
// components
import { TriangleAlert } from 'lucide-react';
import { IAct } from '@newo/api/gateway';
import Message from '@/modules/Chat/components/Message';
// icons
// utils
import { formatDate } from '@/utils/format.ts';
import { DATE_FORMAT } from '@/constants';
import { cn } from '@/utils';
import useActReportDrawerStore from '@/modules/ActReportDrawer/ActReportDrawer.store';
// assets
import styles from '@/modules/Chat/components/AgentMessage/AgentMessage.module.css';

interface AgentMessageProps {
    className?: string;
    act: IAct;
}

const AgentMessage = ({ className, act }: AgentMessageProps) => {
    const selectActToReport = useActReportDrawerStore(
        (state) => state.selectActToReport
    );
    const handleReport = () => {
        selectActToReport(act);
    };

    return (
        <Message.Root className={cn(styles.message, className)}>
            <Message.Header
                className={styles.header}
                connectorIdn={act.connector_idn}
                contactInformation={act.contact_information}
                externalId={act.external_id}
                integrationIdn={act.integration_idn}
            />
            <section>{act.original_text}</section>
            <footer className={styles.footer}>
                <UnstyledButton
                    className="text-xs flex gap-0.25 items-center hover:text-gray-8"
                    onClick={handleReport}
                >
                    <TriangleAlert className="w-4 h-4" /> Report
                </UnstyledButton>
                {formatDate(act.datetime, DATE_FORMAT.FULL_12H)}
            </footer>
        </Message.Root>
    );
};

export default AgentMessage;
